/** Mirrors the backend: notations are matched without spaces or punctuation. */
export const toBisacCodePrefix = (query: string) =>
  query.toUpperCase().replace(/[^A-Z0-9]/g, "");
